/**
 * gráfico torta ou pizza
 */
export const PIE = 'pie';

/**
 * gráfico de barras
 */
export const BAR = 'bar';

/**
 * gráfico de linhas
 */
export const LINE = 'line';

/**
 * Utilização única no relatório para o modelo de barras no evolutivo
 */
export const BARRAS_AGRUPADAS = 'barras_agrupadas';

/**
 * Gráfico de funil
 */
export const FUNNEL = 'funnel';

/**
 * Gráfico de barras horizontal quando a pergunta é do tipo grade
 */
export const HORIZONTAL_STACKED = 'horizontal_bar';

/**
 * Gráfico de barras horizontal quando a pergunta é do tipo grade
 */
export const VERTICAL_STACKED = 'verticalStacked';

/**
 * Gráfico torta ou pizza quando a pergunta é do tipo grade
 */
export const PIE_GRADE = 'pieGrade';

/**
 * Gráfico radar quando a pergunta é do tipo grade
 */
export const RADAR = 'radar';

/**
 * Gráfico de treemap usado pelo card de correlação
 */
export const TREE_MAP = 'tree_map';

/**
 * Gráfico de bolha simples (scatter) usado pelo card de correlação
 */
export const SIMPLE_BUBBLE = 'simple_bubble';

/**
 * Gráfico de bolhas em grafos usado pelo card de correlação
 */
export const GRAPH_BUBBLE = 'graph_bubble';
